import axios from 'axios'
import { getToken, removeToken } from '@/utils/auth'
import router from '@/router'
import store from '@/store'
import { Message } from 'element-ui'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 15000
})

service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      Message.error(res.message || '请求失败')
      if (res.code === 401) {
        removeToken()
        store.commit('user/CLEAR_USER')
        if (window.location.pathname.startsWith('/admin')) {
          router.push('/admin/login')
        }
      }
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res.data
  },
  error => {
    if (error.response && error.response.status === 401) {
      removeToken()
      store.commit('user/CLEAR_USER')
      if (window.location.pathname.startsWith('/admin')) {
        router.push('/admin/login')
      }
      return Promise.reject(error)
    }
    Message.error(error.message || '网络错误')
    return Promise.reject(error)
  }
)

export default service
